/**
 * @generated SignedSource<<2c02efd1e426c5c0deacce860c20bbd3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type HubMapQuery$variables = Record<PropertyKey, never>;
export type HubMapQuery$data = {
  readonly hubs: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly country: string;
        readonly id: string;
        readonly lat: number;
        readonly lng: number;
        readonly name: string;
        readonly postalCode: string;
        readonly services: ReadonlyArray<HubService>;
        readonly street: string;
      };
      readonly sncProducts: {
        readonly totalCount: number;
      };
      readonly status: HubStatus;
    }>;
  };
};
export type HubMapQuery = {
  response: HubMapQuery$data;
  variables: HubMapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "unclaimed": false
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "services",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "active": true
      }
    }
  ],
  "concreteType": "SncProductPage",
  "kind": "LinkedField",
  "name": "sncProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "sncProducts(filter:{\"active\":true})"
},
v5 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v6 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v7 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HubMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "HubPage",
        "kind": "LinkedField",
        "name": "hubs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "kind": "RequiredField",
                "field": (v3/*:: as any*/),
                "action": "THROW"
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "hubs(filter:{\"unclaimed\":false})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HubMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "HubPage",
        "kind": "LinkedField",
        "name": "hubs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "hubs(filter:{\"unclaimed\":false})"
      }
    ]
  },
  "params": {
    "cacheID": "3a1b77583223c6d1bf7504a4d3aac1e0",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubs": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "HubPage"
        },
        "hubs.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Hub"
        },
        "hubs.nodes.id": (v5/*:: as any*/),
        "hubs.nodes.meta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubs.nodes.meta.city": (v6/*:: as any*/),
        "hubs.nodes.meta.country": (v6/*:: as any*/),
        "hubs.nodes.meta.id": (v5/*:: as any*/),
        "hubs.nodes.meta.lat": (v7/*:: as any*/),
        "hubs.nodes.meta.lng": (v7/*:: as any*/),
        "hubs.nodes.meta.name": (v6/*:: as any*/),
        "hubs.nodes.meta.postalCode": (v6/*:: as any*/),
        "hubs.nodes.meta.services": {
          "enumValues": [
            "INSTANT_BUY",
            "ONEDELIVERY",
            "CLICK_N_COLLECT",
            "RAFFLE",
            "LOCK_B2B",
            "LOCK_B2C",
            "SHOP_N_COLLECT"
          ],
          "nullable": false,
          "plural": true,
          "type": "HubService"
        },
        "hubs.nodes.meta.street": (v6/*:: as any*/),
        "hubs.nodes.sncProducts": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "SncProductPage"
        },
        "hubs.nodes.sncProducts.totalCount": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "hubs.nodes.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        }
      }
    },
    "name": "HubMapQuery",
    "operationKind": "query",
    "text": "query HubMapQuery {\n  hubs(filter: {unclaimed: false}) {\n    nodes {\n      id\n      status\n      meta {\n        id\n        city\n        country\n        postalCode\n        name\n        services\n        street\n        lat\n        lng\n      }\n      sncProducts(filter: {active: true}) {\n        totalCount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ba43997cab6f5e0c50b3cf5a0bf12eb";

export default node;
